module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('section', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Player vidéo universel EMPREINTE.COM")]), _vm._v(" "), _c('demo', {
    staticClass: "md-transparent",
    attrs: {
      "type": _vm.getType
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "highlights"
  }, _vm._l((_vm.items), function(item) {
    return _c('section', [_c('div', {
      staticClass: "content",
      class: {
        'selected-card': _vm.type === item.name
      }
    }, [_c('header', [_c('div', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(_vm.describeItem(item.name)))])]), _vm._v(" "), _c('div', {
      staticClass: "item-btns"
    }, [_c('button', {
      ref: item.name,
      refInFor: true,
      staticClass: "button button-small button-sec",
      on: {
        "click": function($event) {
          return _vm.showIntegrateModal(item)
        }
      }
    }, [_vm._v("\n                Intégrer\n              ")]), _vm._v(" "), _c('button', {
      ref: item.name,
      refInFor: true,
      staticClass: "button button-small",
      on: {
        "click": function($event) {
          return _vm.changeType(item.name)
        }
      }
    }, [_vm._v("\n                Visualiser\n              ")])])])])
  }), 0)])], 1), _vm._v(" "), (_vm.showModal && _vm.itemToHandle) ? _c('div', {
    staticClass: "integrate-modal"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "btnClose",
    on: {
      "click": function($event) {
        return _vm.closeIntegrateModal()
      }
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "embed-container"
  }, [_c('div', {
    staticClass: "embed-title"
  }, [_vm._v("Code Embed")]), _vm._v(" "), _c('div', {
    staticClass: "embed-code"
  }, [_c('textarea', {
    attrs: {
      "rows": "6",
      "id": "text-to-copy"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.getCodeEmbed(this.iframeSource))
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button button-small",
    class: {
      'button-sec': _vm.copied
    },
    on: {
      "click": function($event) {
        return _vm.copyToClipboard()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.copied ? "Copié" : "Copier") + "\n            ")])])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a5885be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Highlights.vue
// module id = 164
// module chunks = 1